import { Controller } from "@hotwired/stimulus"

// 옵션이 있는 POS 상품을 담을 때 뜨는 선택 모달 전용 컨트롤러.
// #modals 프레임은 pos 컨트롤러 DOM 범위 밖이므로 직접 fetch로 처리하고,
// 응답 헤더(X-Cart-Summary)를 pos:cart-updated 이벤트로 브로드캐스트해서
// pos_controller.js가 요약/버튼 상태를 갱신하도록 한다.
export default class extends Controller {
  static values = {
    url:       String,
    posItemId: String,
    basePrice: Number
  }

  static targets = ["totalPrice"]

  connect() {
    this.submitting = false
    this.recalculate()
  }

  recalculate() {
    const checked = [...this.element.querySelectorAll("[data-option-choice]:checked")]
    const optionTotal = checked.reduce((sum, el) => sum + (parseInt(el.dataset.priceDelta) || 0), 0)
    const total = this.basePriceValue + optionTotal
    if (this.hasTotalPriceTarget) {
      this.totalPriceTarget.textContent = total.toLocaleString("ko-KR") + "원"
    }
  }

  async add(event) {
    event.preventDefault()
    if (this.submitting) return
    this.submitting = true

    const allGroupIds = [...new Set(
      [...this.element.querySelectorAll("[data-option-choice]")].map(el => el.dataset.groupId)
    )]
    const checked = [...this.element.querySelectorAll("[data-option-choice]:checked")]
    const checkedGroupIds = checked.map(el => el.dataset.groupId)
    const missing = allGroupIds.filter(id => !checkedGroupIds.includes(id))
    if (missing.length > 0) {
      alert("옵션을 선택해주세요.")
      this.submitting = false
      return
    }

    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    const selections = checked.map(el => ({ group_id: el.dataset.groupId, choice_id: el.value }))

    try {
      const response = await fetch(this.urlValue, {
        method:  "POST",
        headers: {
          "X-CSRF-Token":  csrf,
          "Content-Type":  "application/json",
          "Accept":        "text/vnd.turbo-stream.html, application/json"
        },
        body: JSON.stringify({ pos_item_id: this.posItemIdValue, selections })
      })

      if (!response.ok) return

      const html = await response.text()
      document.body.insertAdjacentHTML("beforeend", html)

      const summaryHeader = response.headers.get("X-Cart-Summary")
      if (summaryHeader) {
        window.dispatchEvent(new CustomEvent("pos:cart-updated", { detail: JSON.parse(summaryHeader) }))
      }

      window.dispatchEvent(new CustomEvent("modals:close"))
    } catch (e) {
      console.error("POS option add failed:", e)
      this.submitting = false
    }
  }
}
